import EventToast from '../components/EventToast.vue';

/**
 * Shows an event toast with expandable details
 * @param {Object} vm - Vue instance
 * @param {string} eventName - Event name (e.g., 'view_item_list')
 * @param {Object} eventData - Full event data object
 * @param {string} emoji - Emoji for the title
 * @param {string} variant - Bootstrap variant (success, info, warning, danger)
 * @param {Object} customData - Additional custom data to display
 */
export function showEventToast(vm, eventName, eventData, emoji = '📊', variant = 'info', customData = {}) {
  const h = vm.$createElement;
  
  const toastContent = h(EventToast, {
    props: {
      eventTitle: `${emoji} ${eventName}`,
      eventData: eventData,
      customData: customData
    }
  });

  vm.$bvToast.toast(toastContent, {
    title: `✅ Event Sent`,
    solid: true,
    variant: variant,
    toaster: 'b-toaster-top-right',
    appendToast: true
  });
}
